import { createFileRoute } from "@tanstack/react-router";
import { assert } from "utils";

import { loaderHandler } from "src/lib/loaderHandler";
import { SharedProgramWorkoutPage } from "src/pages/SharedProgramWorkoutPage";

export const Route = createFileRoute("/_public/shared/$sharedId")({
  component: RoutePage,
  ssr: true,
  async loader({ params }) {
    return await loaderHandler(async ({ trpc }) => {
      const shareableId = params.sharedId;
      assert(shareableId !== undefined, "sharableId is required");

      const shareable = await trpc.getShareable.query({
        shareableId: shareableId,
      });

      return {
        data: {
          shareable,
          sharaebleId: shareableId,
        },
      };
    });
  },
  head({ loaderData }) {
    if (!loaderData?.data) {
      return {
        meta: [],
      };
    }

    const name =
      loaderData.data.shareable.type === "program"
        ? loaderData.data.shareable.program.name
        : loaderData.data.shareable.workout.name;

    const author = loaderData.data.shareable.createdBy.name;

    const title = `${name} by ${author} | sztama`;

    return {
      meta: [
        { title },
        {
          property: "og:title",
          content: title,
        },
      ],
    };
  },
});

function RoutePage() {
  return <SharedProgramWorkoutPage />;
}
